import React, { memo } from "react";

const SingleCarBottom = memo(function SingleCarBottom(props)  {
  return (
    <div className='single-car-bottom'>
      <div className='single-car-bottom-image-container'>
        <img src={require(`./images/hero-text-${props.number}.png`)} alt="logo-image"/>
      </div>
      <p>{props.subtitle}</p>
      <p>{props.data}</p>
    </div>
  )
})

export default SingleCarBottom
